/* global jQuery, Namespace */

import Vue from "vue/dist/vue.js";

(function ($, Vue, ns) {
  "use strict";

  var DOM = {
      CONTAINER: "listing_container",
      MOB_REQ_BTN: ".mobile_request_btn",
      MOB_PHONE_BTN: ".getPhone",
      MORE_COMPANIES_BTN: "more-companies",
      NO_MORE_RESULTS: "no-more-results",
      ONLINE_BANNER: "online-banner",
      ONLINE_BANNER_CLOSE: "bannerclose",
      ONLINE_BANNER_LINK: "onlineBannerLink",
    },
    $services = $(".js-services"),
    $showServicesBtn = $(".js-more-services"),
    $hideServicesBtn = $(".js-hide-services"),
    url = "/companies/{comId}/defaultHeadquarter",
    $inject_to = $("#list-items"),
    moreCompaniesBtn = document.getElementById(DOM.MORE_COMPANIES_BTN),
    noMoreResults = document.getElementById(DOM.NO_MORE_RESULTS),
    onlineBanner = document.getElementById(DOM.ONLINE_BANNER),
    onlineBannerClose = document.getElementById(DOM.ONLINE_BANNER_CLOSE),
    onlineBannerLink = document.getElementById(DOM.ONLINE_BANNER_LINK),
    LNK_COMPONENT = "[data-sl]",
    therapyType = window.location.search
      .replace("?", "")
      .split("&")[0]
      .split("=")[1],
    URL = {
      MULTIPLE: "/api/schedule/v1.0/calendars/multipleFromDay",
    },
    VUE_LIST_APPOINTMENT = ".vue_listing_appointment",
    START_APPOINTMENT = "#start_appointment",
    calendarIdArray = [];

  if (document.body.id === "ie_listing") {
    initListing();

    if (typeof window.fbq !== "undefined") {
      window.fbq("track", "Search");
    }
  }

  /*     if (document.body.id === 'ie_listing' && document.documentElement.dataset.rid !== 'online_service_listing') {
        showOnlineBanner();
        hideOnlineBanner();
        onlineBannerLinkTrack();
    } */

  /**
   * Initialize url selector component
   * Detect change event and navigate to new selected option
   */
  function initUrlSelector() {
    var $urlSelectorsList = document.querySelectorAll(LNK_COMPONENT),
      index;

    for (index = 0; index < $urlSelectorsList.length; index++) {
      var urlListener =
        $urlSelectorsList[index].getAttribute("data-url-listener");
      if (urlListener === null) {
        $urlSelectorsList[index].addEventListener("click", navigateToUrl);
      }
    }
  }

  /**
   * Navigate to value option url
   */
  function navigateToUrl() {
    var target = this.getAttribute("data-sl-t"),
      url = this.getAttribute("data-sl"),
      decodedUrl,
      base64Encode = this.getAttribute("data-encoded");

    if (base64Encode === "true") {
      decodedUrl = atob(url);
      url = decodedUrl;
    }

    if (target === "_blank") {
      window.open(url);
    } else {
      window.location.href = url;
    }
  }

  /**
   * Initialize listings
   */
  function initListing() {
    showServices();
    hideServices();
    injectCompanies();

    /* Mobile request button */
    document.querySelectorAll(DOM.MOB_REQ_BTN).forEach(function (button) {
      button.addEventListener("click", checkGeoAndGoRequest);
    });

    document.querySelectorAll(DOM.MOB_PHONE_BTN).forEach(function (button) {
      button.addEventListener("click", getPhoneCall);
    });
  }

  /**
   * Track session navigation
   */
  function trackSession() {
    var navData = document
      .getElementById(DOM.CONTAINER)
      .getAttribute("data-nav");
    ns.utilities.sessionNavigation.setOnServer(JSON.parse(navData));
  }

  /**
   * Check geo location before go to request form
   * @param {Object} event
   */
  function checkGeoAndGoRequest(event) {
    var comId = this.getAttribute("data-company-id");
    event.preventDefault();

    window.App.geoLocationManager.checkGeoIpRequest().then(function (response) {
      if (
        response.success &&
        window.App.geoLocationManager.isAllowedToMakeRequests(
          response.message
        ) === false
      ) {
        window.App.geoLocationManager.setGeoIpLayer(response);
        return;
      }
      window.location.href = "/request?company=" + comId;
    });
  }

  /**
   * Gets phone number from api and executes call
   * @param {Object} event
   */
  function getPhoneCall(event) {
    var comId = this.getAttribute("data-company-id"),
      data;
    event.preventDefault();
    $.ajax({
      type: "GET",
      url: url.replace("{comId}", comId),
    }).done(function (response) {
      if (response.success) {
        data = response.result.shift();
        window.location.href = "tel:" + data.phone;
      } else {
        $(this).click();
      }
    });
  }

  /**
   * Show more services button functionality
   */
  function showServices() {
    $showServicesBtn.on("click", function () {
      $(this).closest($services).addClass("isDisplayed");
      $(this).hide();
      $(this).next().show();
    });
  }

  /**
   * Hide more services button functionality
   */
  function hideServices() {
    $hideServicesBtn.on("click", function () {
      $(this).closest($services).removeClass("isDisplayed");
      $(this).hide();
      $(this).prev().show();
    });
  }

  /**
   * Show loader on Send button.
   */
  function showLoader() {
    moreCompaniesBtn.getElementsByClassName("load")[0].classList.add("show");
  }

  /**
   * Hide loader on Send button.
   */
  function hideLoader() {
    moreCompaniesBtn.getElementsByClassName("load")[0].classList.remove("show");
  }

  /**
   * Load more companies
   */
  function injectCompanies() {
    if (moreCompaniesBtn !== null) {
      var i = 2,
        baseURL = window.location.origin, // https://www.mundopsicologos.com
        search = window.location.search, // ?therapytype=0&service=0&location%5Bpopulation%5D=547&neighborhood=0&pricefilter=0&reviewfilter=0
        page = "&page=",
        path0 = window.location.pathname, // /search
        slice = window.location.pathname.split("/").slice(), // /centros/barcelona
        path2 = window.location.pathname.split("/").slice(2); // barcelona

      // Check if URL path second item exists
      if (path2.length !== 0) {
        var slash = "/";
      } else {
        var slash = "";
      }

      // get first path from URL
      if (slice.length === 2) {
        var path1 = window.location.pathname.split("/").slice(1); // centros from /centros
      } else if (slice.length === 3) {
        var path1 = window.location.pathname.split("/").slice(1, -1); // centros from /centros/barcelona
      } else if (slice.length === 4) {
        var path1 = window.location.pathname.split("/").slice(1, -2), // centros from /centros/ansiedad/barcelona
          path2 = window.location.pathname.split("/").slice(2).join("/"); // ansiedad/barcelona
      }

      // Check if URL has a search parameter
      if (search.length === 0) {
        moreCompaniesBtn.addEventListener("click", function () {
          showLoader();
          var load_from = baseURL + "/" + path1 + "-sp/" + path2 + slash + i;
          $.get(load_from, function (data) {
            var $companies = $(data).find("#companies");
            $companies.appendTo($inject_to);
          })
            .done(function () {
              initUrlSelector();
              hideLoader();
              initAppointmentListing();
            })
            .fail(function () {
              moreCompaniesBtn.classList.add("hide");
              noMoreResults.classList.remove("hide");
            });
          i++;
        });
      } else if (search.length !== 0 && path2.length !== 0) {
        moreCompaniesBtn.addEventListener("click", function () {
          showLoader();
          var load_from =
            baseURL + "/" + path1 + "-sp/" + path2 + slash + i + search;
          $.get(load_from, function (data) {
            var $companies = $(data).find("#companies");
            $companies.appendTo($inject_to);
          })
            .done(function () {
              initUrlSelector();
              hideLoader();
              initAppointmentListing();
            })
            .fail(function () {
              moreCompaniesBtn.classList.add("hide");
              noMoreResults.classList.remove("hide");
            });
          i++;
        });
      } else if (search.length !== 0 && path0 !== "/search") {
        moreCompaniesBtn.addEventListener("click", function () {
          showLoader();
          var load_from = baseURL + "/" + path1 + "-sp/" + slash + i + search;
          $.get(load_from, function (data) {
            var $companies = $(data).find("#companies");
            $companies.appendTo($inject_to);
          })
            .done(function () {
              initUrlSelector();
              hideLoader();
              initAppointmentListing();
            })
            .fail(function () {
              moreCompaniesBtn.classList.add("hide");
              noMoreResults.classList.remove("hide");
            });
          i++;
        });
      } else {
        moreCompaniesBtn.addEventListener("click", function () {
          showLoader();
          var load_from = baseURL + path0 + "-sp" + search + page + i;
          $.get(load_from, function (data) {
            var $companies = $(data).find("#companies");
            if ($companies.children().length <= 1) {
              moreCompaniesBtn.classList.add("hide");
              noMoreResults.classList.remove("hide");
            } else {
              $companies.appendTo($inject_to);
              initUrlSelector();
              hideLoader();
              initAppointmentListing();
            }
          });
          i++;
        });
      }
    }
  }

  /**
   * Show online banner.
   */
  function showOnlineBanner() {
    setTimeout(function () {
      onlineBanner.classList.add("show");
    }, 60000);
  }

  /**
   * Close btn online banner.
   */
  function hideOnlineBanner() {
    if (onlineBannerClose !== null) {
      onlineBannerClose.addEventListener("click", function () {
        onlineBanner.classList.remove("show");
      });
    }
  }

  /**
   * Online banner gtag event.
   */
  function onlineBannerLinkTrack() {
    if (onlineBannerLink !== null) {
      onlineBannerLink.addEventListener("click", function () {
        gtag("event", "click_popup_online", {
          event_category: "list_offline",
        });
      });
    }
  }

  /**
   * Initialize appointment listing behaviour
   */
  function initAppointmentListing() {
    var $availabilities = document.querySelectorAll(VUE_LIST_APPOINTMENT);

    if ($availabilities.length > 0) {
      $availabilities.forEach(saveCalendarId);
      if (calendarIdArray.toString().length) {
        getAvailabilities().then(instanceVueFunctionality);
      }
    }
  }

  /**
   * Save calendar Id in array
   * Save calendar Id in array
   * @param {Object} element
   */
  function saveCalendarId(element) {
    var calendarId = element.getAttribute("data-calendar-id");
    if (calendarId) {
      calendarIdArray.push(calendarId);
    }
  }

  /**
   * Get all list availabilities with one request. Calendar id are comma separated
   * @return {Promise}
   */
  function getAvailabilities() {
    return $.ajax({
      type: "GET",
      data: {
        day: nextDayFormattedDate,
        numberOfDays: 60,
        onlyFreePeriods: 1,
        id: calendarIdArray.toString(),
      },
      url: URL.MULTIPLE,
    }).then(function (response) {
      return response.data;
    });
  }

  /**
   * Get next day date in 'yyyy-mm-dd' format
   * @return {string}
   */
  function nextDayFormattedDate() {
    var date = new Date(),
      TWO_DIGIT = 10,
      day,
      month,
      year;

    date.setDate(date.getDate() + 1);

    day = date.getUTCDate();
    month = date.getUTCMonth() + 1;
    year = date.getUTCFullYear();

    day = day < TWO_DIGIT ? "0" + day : day;
    month = month < TWO_DIGIT ? "0" + month : month;

    return year + "-" + month + "-" + day;
  }

  /**
   *
   * @param {Object} calendars
   */
  function instanceVueFunctionality(calendars) {
    var calendar;
    for (calendar in calendars) {
      if (
        calendars.hasOwnProperty(calendar) &&
        calendars[calendar].hasOwnProperty("isSynchronized") &&
        calendars[calendar].hasOwnProperty("freePeriods") &&
        calendars[calendar]["isSynchronized"]
      ) {
        refreshHours(calendar, calendars[calendar]["freePeriods"]);
      }
    }
  }

  /**
   * Vue instance for listing availability summary
   * @param {String} calendarId
   * @param {Object} periods
   */
  function refreshHours(calendarId, periods) {
    var elSelector =
        VUE_LIST_APPOINTMENT + '[data-calendar-id="' + calendarId + '"]',
      element = document.querySelector(elSelector),
      companyUrl = element.getAttribute("data-url"),
      hqId = element.getAttribute("data-headquarter-id");

    new Vue({
      el: element,
      template: "#listing_availability_summary",
      data: function () {
        return {
          isLoading: true,
          periods: periods,
          companyUrl: companyUrl,
        };
      },
      mounted: function () {
        var TWO_SEC = 1000;
        setTimeout(this.hideLoading, TWO_SEC);
      },
      methods: {
        hideLoading: function () {
          this.isLoading = false;
        },
        /**
         * Navigate to company card and open start appointment modal
         */
        showAvailabilities: function () {
          this.trackAppointmentEvent("see_more_availabilities");
          window.location = this.companyUrl + START_APPOINTMENT;
        },
        /**
         * Request appointment through company card
         * @param {Object} period
         */
        requestAppointment: function (period) {
          var params = {
            appointment_headquarter: hqId,
            appointment_start: period.start,
            appointment_end: period.end,
          };
          this.trackAppointmentEvent("book_appointment_hour");
          window.location =
            this.companyUrl + ns.utilities.objectToQueryString(params);
        },
        trackAppointmentEvent: function (label) {
          if (window.hasOwnProperty("gaqTrackEvent")) {
            window.gaqTrackEvent("CompanyList", "go_company_card", label);
          }
        },
      },
    });
  }
})(jQuery, Vue, Namespace);
